import ErrorModal from "../../../components/molecules/ErrorModal";

/** Caminho da raíz do módulo de documentos */
const DEFAULT_REDIRECT_ROUTE = '/folder_old';

export const wrappedGetDocument = async (
  getDocCallback,
  { navigate = (cUrl) => { window.location.href = cUrl; }, },
) => {
  try {
    const oData = await getDocCallback();

    return oData;
  } catch (oError) {
    if (![406, 403].includes(oError.response?.status)) throw oError;

    const onError = () => navigate(DEFAULT_REDIRECT_ROUTE);
    return {
      rcmpAlert: (
        <ErrorModal onClose={onError} message={oError.aMsgErrors.join('\n')} />
      ),
    };
  }
};
